import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appHideTabs]',
})
export class HideTabsDirective implements OnDestroy {
  @Input() scrollableElement?;
  private lastScrollTop = 0;
  private hideTabs = false;
  private scrollThreshold = 35;
  private contentBottomPadding = 40;
  private routerSubscription: any;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router
  ) {
    // reset the tabs visibility when the route changes
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.resetTabsVisibility();
      });
  }

  ngOnInit() {
    this.resetTabsVisibility();
    this.addBottomPadding();
  }

  ngOnDestroy(): void {
    this.resetTabsVisibility();
    this.routerSubscription?.unsubscribe();
  }

  resetTabsVisibility() {
    this.hideTabs = false;
    this.lastScrollTop = 0;
    this.toggleTabBar();
  }

  @HostListener('ionScroll', ['$event'])
  onScroll(event: any) {
    let scrollTop = event.detail.scrollTop;
    let scrollDiff = scrollTop - this.lastScrollTop;

    // calculate the height of the scrollable element
    let scrollableListHeight = this.scrollableElement?.el.getBoundingClientRect().height;
    const offsetHeight = event.target.offsetHeight;
    let scrollHeight = scrollableListHeight - offsetHeight;

    // check if at the top
    if (scrollTop < 10) {
      this.hideTabs = false;
    }
    // check if at the bottom
    else if (scrollHeight <= scrollTop) {
      this.hideTabs = true;
    }
    // If scrolling down, apply threshold
    else if (scrollDiff > 0 && Math.abs(scrollDiff) > this.scrollThreshold) {
      this.hideTabs = true;
    }
    // If scrolling up, show tabs immediately (no threshold)
    else if (scrollDiff < 0 && Math.abs(scrollDiff) > 5) {
      this.hideTabs = false;
    }

    this.toggleTabBar();
    this.lastScrollTop = scrollTop;
  }

  private toggleTabBar() {
    let tabBar = document.querySelector('ion-tab-bar');
    let fab = document.querySelector('ion-fab');
    // let header = document.querySelector('ion-header');

    if (tabBar) {
      this.renderer.setStyle(
        tabBar,
        'transform',
        this.hideTabs ? 'translateY(100px)' : 'translateY(0)'
      );
      this.renderer.setStyle(
        tabBar,
        'transition',
        'transform 0.3s ease-in-out'
      );
    }
    if (fab) {
      this.renderer.setStyle(
        fab,
        'transform',
        this.hideTabs ? 'translateY(100px)' : 'translateY(-24px)'
      );
      this.renderer.setStyle(fab, 'transition', 'transform 0.3s ease-in-out');
    }

    // if (header) {
    //   this.renderer.setStyle(header, 'transition', 'height 0.3s ease-in-out, opacity 0.3s ease-in-out');
    //   this.renderer.setStyle(header, 'overflow', 'hidden');

    //   if (this.hideTabs) {
    //     this.renderer.setStyle(header, 'height', '0px');
    //     this.renderer.setStyle(header, 'opacity', '0');
    //   } else {
    //     this.renderer.setStyle(header, 'height', 'auto');
    //     this.renderer.setStyle(header, 'opacity', '1');
    //     this.renderer.setStyle(header, 'overflow', 'visible');
    //   }
    // }
  }

  private addBottomPadding() {
    const content = this.el.nativeElement;
    if (content) {
      this.renderer.setProperty(
        content,
        'style',
        `--padding-bottom: ${this.contentBottomPadding}px`
      );
    }
  }
}
